// extracted by mini-css-extract-plugin
module.exports =  {"button":"MicroButton-module_button_aa301","neutral":"MicroButton-module_neutral_d8add","talent":"MicroButton-module_talent_a3455","company":"MicroButton-module_company_a9064"};